import numeral from "numeral"

export default () => {
  return value => {
    return `${numeral(value).format("0,0")}`
  }
}
